import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  BPTemplateSelectedIds: [],
  BPTemplateTreeData: [],
  BPTemplateAppliedData: [],
  BPTemplateSearchQuery: "",
  BPTemplateExpandedItems: [],
};

const BPTemplateTreeSlice = createSlice({
  name: "BPTemplateTree",
  initialState,
  reducers: {
    setBPTemplateSelectedIds: (state, action) => {
      state.BPTemplateSelectedIds = action.payload;
    },
    setBPTemplateTreeData: (state, action) => {
      state.BPTemplateTreeData = action.payload;
    },
    setBPTemplateAppliedData: (state, action) => {
      state.BPTemplateAppliedData = action.payload;
    },
    setBPTemplateSearchQuery: (state, action) => {
      state.BPTemplateSearchQuery = action.payload;
    },
    resetBPTemplateSelection: (state) => {
      state.BPTemplateSelectedIds = [];
      state.BPTemplateAppliedData = [];
    },
    setBPTemplateExpandedItems: (state, action) => {
      state.BPTemplateExpandedItems = action.payload;
    },
  },
});

export const {
  setBPTemplateSelectedIds,
  setBPTemplateTreeData,
  setBPTemplateAppliedData,
  setBPTemplateSearchQuery,
  resetBPTemplateSelection,
  setBPTemplateExpandedItems,
} = BPTemplateTreeSlice.actions;

export default BPTemplateTreeSlice.reducer;
